package com.devi3east.bashbuddy.purchase.domain.models

import kotlinx.serialization.Serializable

@Serializable
data class SubPurchaseInit(
    val organizationId: String,
    val connectedAccountId: String,
    val sessionId: String,
    val sessionUrl: String,
    val totalCents: Long,
    val applicationFeeCents: Long
)